import { render, staticRenderFns } from "./BaseCompany.vue?vue&type=template&id=b1491dc6&scoped=true&"
import script from "./BaseCompany.vue?vue&type=script&lang=js&"
export * from "./BaseCompany.vue?vue&type=script&lang=js&"
import style0 from "./BaseCompany.vue?vue&type=style&index=0&id=b1491dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1491dc6",
  null
  
)

export default component.exports